import { Component, computed, input, output } from '@angular/core';

import { TranslatePipe } from '@camelot/translation';
import { ButtonComponent } from '@camelot/ui';

import { RowType } from '../../../../services/dto/row-type';
import { CamTranslationGrid } from '../../../../translation.service';
import { ADD_ROW_ACTIONS, ALL_ROW_TYPES } from '../context-menu';

@Component({
  imports: [ButtonComponent, TranslatePipe],
  selector: 'cam-editabled-cta-row',
  styleUrl: './editabled-cta-row.component.scss',
  templateUrl: './editabled-cta-row.component.html',
})
export class EditabledCtaRowComponent {
  large = input(false);

  allowedTypes = input<RowType[]>(ALL_ROW_TYPES);

  addLine = output<RowType>();

  protected readonly visibleActions = computed(() =>
    ADD_ROW_ACTIONS.filter(action => this.allowedTypes().includes(action.type))
  );

  protected readonly containerClass = computed(() =>
    this.large()
      ? 'flex-row justify-center g-space-md p-space-lg cta-large'
      : 'flex-row justify-center align-center g-space-sm p-space-sm'
  );

  constructor() {
    CamTranslationGrid.getInstance();
  }
}
